<template>
  

<div  class="card rounded-lg shadow border border-white bg-white h-100 mb-0 pb-3 overflow-auto" >
    <div class="card-header bg-transparent">
             
           

<div class="row">


    <div class="col">
        <h5 class="ml-2 text-secondary font-weight-light  float-left"> <span class="fa fa-file-alt"></span> Gestion Des Soldes : <span class="ml-2 text-success"> </span> </h5>


                        <b-button pill size="sm"  class="ml-3 float-left" variant="outline-primary" @click="exportDox">
                            <i class="fa fa-print"></i>
                    <span> Impr</span> 
                </b-button>
    </div>

                <div class="col-5 p-0">
                        <b-button pill v-b-toggle.collap-categ.collap-articl  class=" ml-0 mr-3 pt-1 pb-1 pr-2 pl-2 float-right" variant="outline-primary">
                        <i class="fa fa-edit fa-1x"></i>     

                        <span> Catégories-Articles</span>           
                        </b-button> 
                </div>

</div>


    </div>




    <div class="row card-body h-100 p-0 m-0">

  
                <b-collapse id="collap-categ"   class="col-2 h-100 mr-0 ml-0 mt-2 p-0">

                            <div class="card border-success h-100 overflow-auto ml-2">
                            <div class="card-header  bg-success border-success p-1">
                                            <b-form-input v-model="searchCateg" class="border-info" id="search-cat" size="sm" placeholder="Chercher ..." type="search"></b-form-input>
                                           
                            </div>

                            <b-list-group flush >
                            <b-list-group-item  v-for="item in filterCategorie" :key="item.id" button class="p-1" variant="success" @click="cat_click(item)" >
                                    {{ item.nom }} 

                            </b-list-group-item>

                            </b-list-group>
                            </div>



                    
                </b-collapse>


                <b-collapse id="collap-articl"   class="col-2 h-100 ml-2 mr-0 mt-2 p-0">


                            <div class="card border-info h-100  overflow-auto">
                            <div class="card-header  bg-info border-info p-1">
                                <b-form-input v-model="serchArt"  class="border-info" id="search-art" size="sm" placeholder="Chercher ..." type="search"></b-form-input>
                            
                                        <div class="custom-control custom-switch form-control-sm ml-1">
                                        <input type="checkbox"
                                        class="custom-control-input" 
                                        id="isCodeBarreSearch"
                                                v-model="isCodeBarreSearch"
                                                name="isCodeBarreSearch"
                                                value=true
                                                unchecked-value=false>

                                        <label class="custom-control-label text-white  mb-0" for="isCodeBarreSearch">Code Barre</label>
                                        </div>
                            </div>

                            <b-list-group flush  >
                       
                            <b-list-group-item  v-for="item in filterArticle" :key="item.id" button class="p-1" variant="info" @click="add_Article_click(item)">
                                 {{ item.ref }}
                                 <p> <small>{{item.description}}</small> </p>
                                 </b-list-group-item>

                          

                            </b-list-group>
                            </div>






                </b-collapse>

                <div class="col h-100 overflow-auto mt-2 mr-2 ml-0">



                            
                <div class="btn card border border-light shadow mt-0">
                        <div class=" d-flex justify-content-center pt-1 text-info mb-2">
                                <h5 class="font-weight-light ">Liste Des Soldes</h5>
                        </div>

                        <b-table 
                        sort-icon-left
                        small 
                        responsive 

                        :fields="fieldsArtCaise" 
                        :items="ArticlesList"
                        >
                            <template #cell(actions)="rowAr">

                                    <b-button pill size="sm"  class="mr-2 mt-1 mb-1 float-right" variant="outline-danger" @click="Dellart_click(rowAr.item.id)">
                                                <i class="fa fa-trash-alt"></i>
                                        
                                    </b-button>
                            </template>
                        
                        </b-table> 

                </div>


                       


                </div>

  </div>






    <!-- le modal -->
    <b-modal id="banqModal" :title="itemFormArt.ref" size="lg" hide-footer>
           <form @submit.prevent="ArthandleSubmit">


                        <div class=" d-flex justify-content-center pt-1 text-info mb-1">
                                <h5 class="font-weight-normal ">{{itemFormArt.ref}}</h5>

   
                               
                        </div>
                        <div class=" d-flex justify-content-center pt-1 mb-2">
                                 <p class="font-weight-light ">{{ itemFormArt.description}}</p>     
                        </div>

                        <div class=" d-flex justify-content-center pt-1 text-primary mb-4">
                                <h5 class="font-weight-normal ">Prix : {{itemFormArt.prix_vent}} DH</h5>
                        </div>



            <div class="row">

            <div class="form-group col">
                <label for="percent">Pourcentage</label>
                <input type="text" v-model="itemFormArt.percent" id="percent" name="percent" class="form-control"
                    :class="{ 'is-invalid': isSubmitted && $v.itemFormArt.prix_vent.$error }" />
                <div v-if="isSubmitted && !$v.itemFormArt.percent" class="invalid-feedback">Ce champ est obligatoire !!</div>
                <div v-if="isSubmitted && !$v.itemFormArt.percent" class="invalid-feedback">Entrez une valeur numérique !!</div>
            </div>


            <div class="form-group col">

                
                <b-button    class="mr-2 float-left p-0" variant="link" @click="calcule_prix">
                    <i class="fa fa-calculator"></i>
                    <span> </span> 
                </b-button>

                <label for="solde">Nouveau Prix </label>


                <input type="text" v-model="itemFormArt.solde" id="solde" name="solde" class="form-control"
                    :class="{ 'is-invalid': isSubmitted && $v.itemFormArt.solde.$error }" />
                <div v-if="isSubmitted && !$v.itemFormArt.solde" class="invalid-feedback">Ce champ est obligatoire !!</div>
                <div v-if="isSubmitted && !$v.itemFormArt.solde" class="invalid-feedback">Entrez une valeur numérique !!</div>
            </div>



            </div>


            <div class="form-group">
                <button type="submit" class="btn  btn-primary btn-block">{{ModalType}}</button>
            </div>

        </form>

    </b-modal>







      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>

 </div>






  
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required,decimal} from "vuelidate/lib/validators";

import { HeadingLevel,PageNumber, PageNumberFormat,Footer, Header, Table,TableCell,TableRow,Document, Paragraph,WidthType,VerticalAlign,AlignmentType, Packer, TextRun } from "docx";
import { saveAs } from 'file-saver';

export default {


 
    computed: {
        entet_pag() {

      if(this.$store.getters.get_entete)
      {
            return this.$store.getters.get_entete;
      }
      else
      {
            return '';
      }
    },
    sousentet_pag() {

      if(this.$store.getters.get_sousentete)
      {
            return this.$store.getters.get_sousentete;
      }
      else
      {
            return '';
      }
    },
    pied_pag() {

      if(this.$store.getters.get_pied)
      {
            return this.$store.getters.get_pied;
      }
      else
      {
            return '';
      }
    },
    filterArticle() {
            return this.listArtCaisse.filter(article => {

            if(this.isCodeBarreSearch)
            {
                if(article.code_bar)
                {
                return article.code_bar.toLowerCase().includes(this.serchArt.toLowerCase())
                }

            }
            else
            {
                return article.ref.toLowerCase().includes(this.serchArt.toLowerCase())
            }

      })
    },
    filterCategorie() {
            return this.listCatCaisse.filter(category => {
            return category.nom.toLowerCase().includes(this.searchCateg.toLowerCase())   
      })
    }
    },
    mounted(){
            this.fetchListDesSolde()

            this.fetchListCatPOS()

    },
    data () {
		return {

            listCatCaisse: [],
            fieldsCatCaise: [
                {key: 'nom', label: 'Catégories'},
                { key: 'actions', label: '' }
            ],
            listArtCaisse: [],
            fieldsArtCaise: [
                {key: 'ref', label: 'Article'},
                {key: 'cat_pos', label: 'Catégorie'},
                {key: 'prix_vent', label: 'Prix Vente'},
                {key: 'solde', label: 'Prix Solde'},
                { key: 'actions', label: '' }
            ],
            itemFormArt: {
                    id:'',
                    ref:'',
                    code_bar:'',
                    description:'',
                    prix_vent:'',
                    article_id:'',
                    pos_categorie_id:'',                   
                    is_solde:'',
                    percent:'',
                    solde:''
                    
                    },


            isCodeBarreSearch: false,
            searchCateg:'',
            serchArt:'',
            ArticlesList:[],
            itemForm: {
                    id:'',
                    ref:'',
                    code_bar:'',
                    description:'',
                    qte:'',
                    nom_lot:'',
                    lot_id:'',
                    article_id:'',
                    is_lot_manag:''},
            itemFormLot: {
                    nom:'',
                    qte:'',
                    date:new Date().toJSON().slice(0,10).replace(/-/g,'-'),
                    date_exp:new Date().toJSON().slice(0,10).replace(/-/g,'-'),
                    depot_id:'',
                    article_id:''},
            ListLots:[],



            ModalType:'Ajouter',

            isSubmitted: false,
            isLoading: false
		}
    },
    validations: {
            itemFormArt: {
                ref: {
                    required
                },
                prix_vent: {
                    required,
                    decimal
                },
                article_id: {
                    required
                },
                pos_categorie_id: {
                    required,
                },
                is_solde: {
                    required,
                },
                percent: {
                    required,
                    decimal
                },
                solde: {
                    required,
                    decimal
                }
            }

    },
    methods:{



exportDox()
        {


        let datrw =[new TableRow({
                    children: [
                        new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                            children: [
                                            new TextRun({
                                            text: "Référence",
                                            color: '0f31b5',
                                            bold: false,
                                            font: "Segoe UI"
                                            }),
                                        ],
                                            spacing: {
                                                before: 100,
                                                after: 100
                                            },
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),

                        
                        new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                        children: [
                                            new TextRun({
                                            text: "Catégorie",
                                            color: '0f31b5',
                                            bold: false,
                                            font: "Segoe UI"
                                            }),
                                        ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),
                        new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                        children: [
                                            new TextRun({
                                            text: "Prix Vente",
                                            color: '0f31b5',
                                            bold: false,
                                            font: "Segoe UI"
                                            }),
                                        ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),

                        new TableCell({
                                                width: {
                                                    size: 4000,
                                                    type: WidthType.DXA,
                                                },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                        children: [
                                            new TextRun({
                                            text: "Prix Solde",
                                            color: '0f31b5',
                                            bold: false,
                                            font: "Segoe UI"
                                            }),
                                        ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        })

                    ],
                })]

        this.ArticlesList.forEach(function(item){

        let r = new TableRow({
                    children: [
                        new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        children: [
                                        new TextRun({
                                            text: item.ref,
                                            color: '000000',
                                            bold: true,
                                            }),
                                                ],
                                        spacing: {
                                        before: 50,
                                        after: 50
                                    },
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),
                     new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                        children: [
                                        new TextRun({
                                            text: item.cat_pos,
                                            color: '000000',
                                            bold: true,
                                            }),
                                                ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),


                        new TableCell({
                            width: {
                                size: 4000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                      children: [
                                        new TextRun({
                                            text: item.prix_vent.toString(),
                                            color: '000000',
                                            bold: true,
                                            }),
                                                ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),

                        new TableCell({
                            width: {
                                size: 2000,
                                type: WidthType.DXA,
                            },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [new Paragraph({
                                        
                                        children: [
                                        new TextRun({
                                            text: item.solde.toString(),
                                            color: '000000',
                                            bold: true,
                                            }),
                                                ],
                                        heading: HeadingLevel.HEADING_3,
                                        alignment: AlignmentType.CENTER,
                                    })],
                        }),


                    ],
                })

        datrw.push(
        r
        )
        });

        const table = new Table({

            rows:  datrw
        })

        const doc = new Document({

    sections: [
        {


                    properties: {
                        page: {
                            pageNumbers: {
                                start: 1,
                                formatType: PageNumberFormat.DECIMAL,
                            },
                            margin:{
                                left:500,
                                right:500
                            }
                        },
                    },
                    headers: {
                        default: new Header({
                            children: [
                        new Paragraph({
                                    children: [
                            new TextRun({
                                text: this.entet_pag,
                                color: '000000',
                                bold: true,

                                }),
                                    ],
                                    heading: HeadingLevel.TITLE,
                                    alignment: AlignmentType.CENTER,
                                }),

                        new Paragraph({
                                    children: [
                            new TextRun({
                                text: this.sousentet_pag,
                                color: '000000',
                                bold: false,
                                font: "Segoe UI"
                                })

                                    ],
                                border: {
                                bottom: {
                                        color: "000000",
                                        space: 4,
                                        value: "single",
                                        size: 10,
                                    }},
                                    heading: HeadingLevel.HEADING_1,
                                    alignment: AlignmentType.CENTER,
                                }),




                            ],
                        }),
                    },
                    footers: {
                        default: new Footer({
                            children: [

                        new Paragraph({
                                    children: [
                            new TextRun({
                                text: this.pied_pag,
                                color: '000000',
                                bold: false,
                                })

                                    ],
                                border: {
                                top: {
                                        color: "000000",
                                        space: 4,
                                        value: "single",
                                        size: 10,
                                    }},
                                    heading: HeadingLevel.HEADING_3,
                                    alignment: AlignmentType.CENTER,
                                }),

                                new Paragraph({
                                    alignment: AlignmentType.RIGHT,
                                    children: [
                                        new TextRun({
                                            children: ["Page : ", PageNumber.CURRENT],
                                            color: '000000'
                                        }),
                                        new TextRun({
                                            children: [" Sur ", PageNumber.TOTAL_PAGES],
                                            color: '000000'
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    },




                    children: [

                        new Paragraph({



                            children: [

                                new TextRun({
                                text: "Liste Des Soldes",
                                color: '000000',
                                bold: false,
                                font: "Segoe UI"
                            }), 


                            ],

                            heading: HeadingLevel.HEADING_2,
                                                alignment: AlignmentType.CENTER,

                                spacing: {
                                    after: 300,
                                    before: 300
                                },
                        }),




                        table
                        
                        ]


        }]



                });








            Packer.toBlob(doc).then(blob => {

                    saveAs(blob, "Liste_soldes.docx");

            });

        },










        calcule_prix()
        {

        if(this.itemFormArt.percent > 0)
        {
        this.itemFormArt.solde = Number(this.itemFormArt.prix_vent-(this.itemFormArt.prix_vent*this.itemFormArt.percent*0.01)).toFixed(2)

        }
        else
        {
                        this.flashMessage.show({
                        status: 'info',
                        title: 'Entrez un pourcentage valide et Reésayez !!',
                        })

                        this.itemFormArt.solde =0
        }

        },
        ArthandleSubmit() {

                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {

                    this.banqueEdit()

                }

        },
        banqueEdit(){



            this.isLoading=true;

            this.$http.patch('/posArticles/'+this.itemFormArt.id,{
                    ref:this.itemFormArt.ref,
                    code_bar:this.itemFormArt.code_bar,
                    description:this.itemFormArt.description,
                    prix_vent:this.itemFormArt.prix_vent,
                    article_id:this.itemFormArt.article_id,
                    pos_categorie_id:this.itemFormArt.pos_categorie_id,
                    is_solde:this.itemFormArt.is_solde,
                    percent:this.itemFormArt.percent,
                    solde:this.itemFormArt.solde


                })
                .then(response => {

                    this.isLoading=false;
                    this.$bvModal.hide('banqModal')

                    let index = this.ArticlesList.findIndex(item => item.id === this.itemFormArt.id)
                    this.ArticlesList.splice(index, 1,response.data.data)
                    
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données modifiées',
                    message: 'Les données sont modifiées correctement'
                    })

                    this.fetchListDesSolde()//recharger la liste

                    })
                    .catch(error=> {console.log(error)
                    this.isLoading=false;


                    this.flashMessage.show({
                    status: 'error',
                    title: 'Erreur De Modification',
                    message: 'Impossible  de modifier les données .. Réessayez !!'
                })
                });

        },
        add_Article_click(item) {


                        this.itemFormArt.id=item.id,
                        this.itemFormArt.ref=item.ref,
                        this.itemFormArt.code_bar=item.code_bar,
                        this.itemFormArt.description=item.description,
                        this.itemFormArt.prix_vent=item.prix_vent,
                        this.itemFormArt.article_id=item.article_id,
                        this.itemFormArt.pos_categorie_id=item.pos_categorie_id,
                        this.itemFormArt.is_solde=1,
                        this.itemFormArt.percent=0,
                        this.itemFormArt.solde=0,
                

        this.ModalEdit=false;
        this.ModalType='Ajouter'

        this.$root.$emit('bv::show::modal', 'banqModal')
        },
        Dellart_click(id_art)
        {

                this.$confirm("Voulez-vous vraiment supprimer cet élément ??")
                 .then(() => {

            this.isLoading=true;

            this.$http.get('/dellSoddePos/'+id_art)
                .then(response => {
                console.log(response.data)

                this.isLoading=false;   
                this.flashMessage.show({
                status: 'success',
                title: 'Données Supprimées',
                message: 'Les données sont supprimées correctement'
                })

                this.fetchListDesSolde()//recharger la liste

                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Suppression',
                message: 'Impossible  de supprimer les données .. Réessayez !!'
                })
                });






                })
                .catch(error=> {
                console.log(error)

                });
        },
        cat_click(item)
        {
                   
                    this.isLoading=true;
                    this.$http.get('/posArtcat/'+item.id)
                    .then((result) => {
                                this.listArtCaisse = result.data.data
                                  this.isLoading=false;
                                    
                                    this.itemFormArt.pos_categorie_id=item.id
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },
        fetchListCatPOS()
        {
                    this.isLoading=true;
                    this.$http.get('/posCategors')
                    .then((result) => {
                                this.listCatCaisse = result.data.data
                                this.isLoading=false;

                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },
         fetchListDesSolde()
        {
                    this.isLoading=true;
                    this.$http.get('/posSoldeList')
                    .then((result) => {
                                this.ArticlesList = result.data.data
                                this.isLoading=false;

                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });

        },


        },
        components: {
                    Loading      
        }


}
</script>

<style>
/*------scroll bar---------------------*/

::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #9cc7f9;
  border: 0px none #ffffff;
  border-radius: 0px;
}
::-webkit-scrollbar-thumb:hover {
  background: #9cc7f9;
}
::-webkit-scrollbar-thumb:active {
  background: #9cc7f9;
}
::-webkit-scrollbar-track {
  background: transparent;
  border: 0px none #ffffff;
  border-radius: 60px;
}
::-webkit-scrollbar-track:hover {
  background: transparent;
}
::-webkit-scrollbar-track:active {
  background: transparent;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

</style>